import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useLocation, useNavigate } from "react-router-dom";

const LoginWarning = ({ cancelText = "Go Back", onCancel }) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Modal show={true} backdrop="static" keyboard={false} centered>
      <Modal.Body className="pt-0">
        <div className="d-flex justify-content-center">
          <img src={process.env.PUBLIC_URL + "/assets/images/not-login.png"} className="w-75" alt="" />
        </div>
        <h5 className="fw-normal text-center">
          You're not logged-in please login or register to continue...
        </h5>
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center">
        <div className="d-flex flex-wrap justify-content-between w-100">
          <Button
            variant="warning"
            className="m-0 text-white fw-semibold"
            style={{ width: "49%" }}
            onClick={() => {
              navigate("/app/login");
              sessionStorage.setItem("lastPage", location.pathname);
            }}
          >
            Login
          </Button>
          <Button
            variant="primary"
            className="m-0 bg-dark text-white fw-semibold"
            style={{ width: "49%" }}
            onClick={() => {
              navigate("/app/sign-up");
              sessionStorage.setItem("lastPage", location.pathname);
            }}
          >
            Register
          </Button>
        </div>
        <Button
          variant=""
          className="m-0 fw-semibold pt-3"
          onClick={() => {
            if (onCancel) onCancel();
            else navigate(-1);
          }}
        >
          {cancelText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LoginWarning;
